import { Button, Flex } from '@chakra-ui/react';
import { useContext, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link as ReactRouterLink } from 'react-router-dom';
import { AuthenticatedComponent } from '../../auth/keycloak';
import PageDataContext from '../../context/PageDataContext';
import { usePageDataCache } from '../../hooks/usePageDataCache';
import { getUserSubscription, SubscriptionDef } from '../../service/inventory';
import { getUserFollowersCount, getUserFollowingCount } from '../../service/social';
import { getQuantityStringByIntl } from '../../util/label';

export const PrivateFollowStats: AuthenticatedComponent = ({ keycloak }) => {
    const intl = useIntl();
    const { isLoadFromCache } = useContext(PageDataContext);
    const localStoragePrefix = 'PrivateFollowStats';

    const [followersCount, setFollowersCount] = usePageDataCache(
        `${localStoragePrefix}_followersCount`,
        0,
    );
    const [followingCount, setFollowingCount] = usePageDataCache(
        `${localStoragePrefix}_followingCount`,
        0,
    );

    const [subscriptions, setSubscriptions] = usePageDataCache<SubscriptionDef[]>(
        `${localStoragePrefix}_subscriptions`,
        [],
    );

    const countActiveSubscriptions = () => {
        let active = 0;

        subscriptions.map((sub) => {
            if (Boolean(sub.status.inactive) !== true) {
                ++active;
            }
        });

        return active;
    };

    useEffect(() => {
        async function loadFollowStats() {
            const userID = keycloak.subject;
            const followingCount = await getUserFollowingCount(userID, keycloak.token);
            const followersCount = await getUserFollowersCount(userID);
            setFollowingCount(followingCount);
            setFollowersCount(followersCount);
        }

        async function loadSubscriptions() {
            const subList = await getUserSubscription(keycloak.subject, '', '', keycloak.token);
            setSubscriptions(subList);
        }

        if (!isLoadFromCache) {
            loadFollowStats();
            loadSubscriptions();
        }
    }, []);

    return (
        <Flex className={'private-follow-stats'}>
            <Flex className={isMobile ? 'button-list' : 'button-list-browser'}>
                <Button className={'following-button'} as={ReactRouterLink} to="/follow-stats">
                    <FormattedMessage
                        id="private_profile.following_count"
                        defaultMessage={'Following {count}'}
                        values={{
                            count: getQuantityStringByIntl(followingCount, intl),
                        }}
                    />
                </Button>
                <Button
                    className={'subscriptions-button'}
                    as={ReactRouterLink}
                    to="/creator-subscriptions"
                >
                    <FormattedMessage
                        id="private_profile.subscriptions_count"
                        defaultMessage={'Subscriptions {count}'}
                        values={{
                            count: countActiveSubscriptions(),
                        }}
                    />
                </Button>
            </Flex>
        </Flex>
    );
};
